// extracted by mini-css-extract-plugin
module.exports = {"base":"patent_base__3cDJS","data":"patent_data__YxZP1","actions":"patent_actions__wK3wU"};